<template>
  <div class="buttonBack" :style="'width: '+width+'%; margin:0 '+((100-width)/2)+'%;'">
    <div class="buttonTitle" :style="selectButton?'color:'+fontSelectColor:'color:'+fontColor" @click="onClick">{{ title }}</div>
    <div class="leftBack"><img :src="selectButton?imageSelect:image"></div>
    <div class="rigthBack"><img :src="selectButton?imageSelect:image"></div>
  </div>
</template>
<script>
// import request from '@/utils/request'
export default {
  props: {
    // eslint-disable-next-line
    title:{
      default: '按钮'
    },
    // eslint-disable-next-line
    image: {
      default: '/grouptest/score/buttonOrangeBack.png'
    },
    // eslint-disable-next-line
    imageSelect: {
      default: '/grouptest/score/buttonOrangeBack.png'
    },
    // eslint-disable-next-line
    width: {
      default: 80
    },
    // eslint-disable-next-line
    fontColor: {
      default: '#000'
    },
    // eslint-disable-next-line
    fontSelectColor: {
      default: '#fff'
    }
  },
  data() {
    return {
      selectButton: false
    }
  },
  methods: {
    onClick() {
      this.selectButton = true
      this.$emit('click')
      setTimeout(() => {
        this.selectButton = false
      }, 200)
    }
  }

}
</script>
<style scoped>

.buttonBack{
    width: 50%;
    height: 2em;
    margin: 0.5em 25%;
    position: relative;
    overflow: hidden;
    line-height: 2em;
}
.buttonBack .leftBack{
    width: calc(100% - 1em);
    height: 100%;
    overflow: hidden;
}
.buttonBack .leftBack img{
    height: 100%;
}
.buttonBack .rigthBack{
    position: absolute;
    height: 100%;
    right: 0;
    top: 0;
    left: 1em;
    width: calc(100% - 1em);
    z-index: 1;
    overflow: hidden;
}
.buttonBack .rigthBack img{
    float: right;
    height: 100%;
}
.buttonBack .buttonTitle{
    text-align: center;
    position: absolute;
    z-index: 2;
    width: 100%;
    font-size: 0.9em;
    font-weight: 700;
}
</style>
